import { useAppVersion } from '@/hooks/useAppVersion'

export function Footer() {
  const { version } = useAppVersion()

  return (
    <footer className="border-t border-border px-6 py-3 text-xs text-muted-foreground flex items-center justify-between">
      <span>Xident Admin {version ? `v${version}` : ''}</span>
      <div className="flex items-center gap-4">
        <a
          href="https://status.xident.io"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground transition-colors"
        >
          Status
        </a>
        <a
          href="https://docs.xident.io"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground transition-colors"
        >
          Docs
        </a>
      </div>
    </footer>
  )
}
